<div class="wrapperStyle">
  <div id="main-wrapper">
    <ngx-loading [show]="showSpinner" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
    <app-header (found)="handleResults($event)"></app-header>
    <main>
      <div class=" tab inner-tab-container dashboardContainer main-background-care topSpace main-container">
        <app-search-results [resultGridList]="data"></app-search-results>
        <!-- Nav tabs -->
        <!-- <ul class="nav nav-tabs cup-detail-header" role="tablist">
        <li role="presentation" class="active">
          <div class="labels"> Documents </div>
          <a href="#Section1" aria-controls="home" role="tab" data-toggle="tab" style="min-width: 16em"></a>
        </li>
      </ul> -->

      <h1 class="carelon-page-title m-t-20">View Clinical Documentation</h1>

      <div class="dashboard-content">
        <div class="tab-pane dashboard-pane" [style.display]="isShowOverView ? 'block' : 'none'">
          <div class="row">
            <div
              class="form-group col-md-4 col-xs-12 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis">
              <label for="memberHealthPlan"><span class="required">*</span> SITE</label>
              <cup-autocomplete class="input-underline" [colWidth]="16" [(ngModel)]="selectedSite"
                [autoCompleteModel]="selectedSite" [autoCompleteDynamic]="true"
                [autoCompleteOptions]="sites" (autoCompleteModelChange)="setProviders($event)"
                emptyMessage='No Sites Found'
              [autoCompletePlaceholder]="'Select Site'"></cup-autocomplete>
            </div>

            <div class="form-group col-md-4 col-xs-12 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis"
              style="position: relative;">
              <div>
                <label for="provider"><span class="required">*</span> PRIMARY CARE
              PHYSICIANS</label>
              <cup-autocomplete [isDisabled]="pcpDropdownforDCE" class="input-underline"
                [colWidth]="16" [autoCompleteModel]="selectedProviderModel"
                emptyMessage='No Providers Found' [autoCompleteDynamic]="true"
                [autoCompleteOptions]="providers"
                (autoCompleteModelChange)="onProvidersSubmit($event)"
                [autoCompletePlaceholder]="'Select PRIMARY CARE PHYSICIANS'"
                [(ngModel)]="selectedProviderModel">
              </cup-autocomplete>
            </div>
          </div>

          <div class="m-t-2 m-r-20" style="margin-bottom: 18px;">
            @if (selectedMembers.length == 0 && this.selectedSite == undefined) {
              <div>
                Please Select Primary care physician
              </div>
            }
            @if (selectedMembers.length == 0 && this.selectedSite != undefined) {
              <div>
                Data not available for selected Primary care physician
              </div>
            }

          </div>

          @if (allMemberList.length > 0) {
            <div class="memberSearchSection">
              <label for="memberSearch">Search Member</label>
              <input type="text" class="form-control memberSearch"
                placeholder="Search by Member ID or Name or DOB" name="memberSearch" id="memberSearch"
                [(ngModel)]="searchInput" (keyup)="onSearchMember($event)">
              </div>
            }
            @if (selectedMembers.length > 0) {
              <div>
                <table class="table custom-table myTable stcikyHeaders" id="myTable">
                  <thead>
                    <tr class="table-header stickyHeader">
                      <th>Member ID</th>
                      <th>Member Name</th>
                      <th>Date of Birth</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (memberDetails of pagedMembers; track memberDetails) {
                      <tr class="border">
                        <td>{{memberDetails.memberHmoID}}</td>
                        <td>{{memberDetails.member_NAME}}</td>
                        <td>{{memberDetails.memberDOB | date:'MM/dd/yyyy'}}</td>
                        <td> <a class="view-cmd"
                          (click)="navigateToPatientDashboard(memberDetails)"> View Details
                        </a> </td>
                      </tr>
                    }
                  </tbody>
                </table>
                <mat-paginator [length]="selectedMembers.length" [pageSize]="pageSize"
                  [pageSizeOptions]="[5, 10, 20, 50]" (page)="onPageChange($event)"
                [pageIndex]="currentPage"> </mat-paginator>
              </div>
            }



          </div>
        </div>
      </div>
    </div>
  </main>
</div>


<app-footer></app-footer>
</div>